export const datePickerFormat = (date: string, joinOn: string = '-', splitOn = '/') => {
  return date?.split(splitOn).reverse().join(joinOn);
};
